import { useState, useEffect } from 'react';

const windowSizes = () => ({
  innerWidth: window.innerWidth,
  innerHeight: window.innerHeight,
  outerWidth: window.outerWidth,
  outerHeight: window.outerHeight
});

/**
 * Hook for retrieving the current window size
 */
const useWindowResize = () => {
  let [windowSize, setWindowSize] = useState(windowSizes());

  useEffect(() => {
    window.addEventListener('resize', () => setWindowSize(windowSizes()));

    return () => {
      window.removeEventListener('resize', setWindowSize(windowSizes()));
    };
  }, []);

  return windowSize;
};

export default useWindowResize;
